import moment from 'moment';
import { convertDateDisplay, formatDate } from '../../utilities/DatetimeUtils';
export const optionIsPublic = [
    { value: true, label: 'เปิดเผยสาธารณะ' },
    { value: false, label: 'เฉพาะผู้จัดกิจกรรม/ตามรายชื่อที่กำหนด' },
]; // การเผยแพร่กิจกรรม

export const optionStatus = [
    {
        id: '1',
        label: 'ยังไม่เปิดลงทะเบียนล่วงหน้า',
    },
    {
        id: '2',
        label: 'ระหว่างลงทะเบียนล่วงหน้า',
    },
    {
        id: '3',
        label: 'ปิดลงทะเบียนล่วงหน้า',
    },
    {
        id: '4',
        label: 'ระหว่างการจัดกิจกรรม',
    },
    {
        id: '5',
        label: 'สิ้นสุดกิจกรรม',
    },
    {
        id: '6',
        label: 'ยกเลิกกิจกรรม',
    },
]; //กำหนดรูปแบบการลงทะเบียนเข้างาน

export const EVENT_STATUS = {
    CANCELLED: '6', //ยกเลิกกิจกรรม
};

export const optionIsUnlimitedCapacity = [
    { value: false, label: 'ตามจำนวณที่กำหนด' },
    { value: true, label: 'ไม่กำหนด' },
]; //เงื่อนไขการลงทะเบียน

export const optionIsRequiredCheckIn = [
    {
        value: false,
        label: 'ไม่กำหนด (ไม่ต้องลงทะเบียนเข้างานในวันจัดกิจกรรม)',
    },
    { value: true, label: 'ณ สถานที่จัดกิจกรรม' },
]; //กำหนดรูปแบบการลงทะเบียนเข้างาน

export const optionRegisterType = [
    {
        value: 1,
        label: 'ผู้ลงทะเบียนล่วงหน้า',
    },
    {
        value: 2,
        label: 'ผู้ลงทะเบียนเข้าร่วมกิจกรรม',
    },
];

export const optionAttendeeType = [
    {
        value: true,
        label: 'พนักงานและลูกจ้างพนักงาน',
    },
    {
        value: false,
        label: 'บุคลากรภายนอก',
    },
];

export const optionIsInternal = [
    { value: true, label: 'พนักงานและลูกจ้างพนักงาน' },
    { value: false, label: 'บุคคลภายนอก' },
]; // การเผยแพร่กิจกรรม

const DateFields = [
    'eventStartDate',
    'eventEndDate',
    'reserveStartDate',
    'reserveEndDate',
]; // Date field in format <YYYY-MM-DD>

const TimeFields = [
    'eventStartTime',
    'eventEndTime',
    'reserveStartTime',
    'reserveEndTime',
];

export const firstCol = [
    'reserveStartDate',
    'reserveEndDate',
    'isRequiredCheckin',
    'status',
];

export const secondCol = [
    'hasCapacity',
    'isAllowAnyOne',
    'checkInLeadTime',
    'reserveFile',
];

export const thirdCol = firstCol;

export const fourthCol = ['hasCapacity', 'isAllowAnyOne', 'reserveFile'];

export const fifthCol = firstCol;

export const sixthCol = [
    'hasCapacity',
    'internalCapacity',
    'externalCapacity',
    'reserveFile',
];

export const fifthColRequired = [
    'reserveStartDate',
    'reserveEndDate',
    'status',
    'isRequiredCheckin',
    'reserveFile',
];

export const sixthColRequired = [
    'hasCapacity',
    'internalCapacity',
    'externalCapacity',
    'checkInLeadTime',
];

export const seventhCol = ['isRequiredCheckin', 'status'];

export const eighthCol = ['reserveFile'];

export const ninthCol = seventhCol;

export const tenthCol = ['checkInLeadTime', 'reserveFile'];

const normalizeTimeField = (time) => {
    if (typeof time === 'string' && /^\d{2}:\d{2}$/.test(time)) {
        return time;
    }
    return moment(time).format('HH:mm');
};

export const validateEventForm = (values) => {
    const errorMsg = 'กรุณาระบุข้อมูล';
    const errors = {};
    if (!values.eventName) {
        errors.eventName = errorMsg;
    }

    if (!values.venue) {
        errors.venue = errorMsg;
    }

    if (!values.eventDescription) {
        errors.eventDescription = errorMsg;
    }

    if (!values.eventStartDate) {
        errors.eventStartDate = errorMsg;
    }

    if (!values.eventStartTime) {
        errors.eventStartTime = errorMsg;
    }

    if (!values.eventEndDate) {
        errors.eventEndDate = errorMsg;
    }

    if (!values.eventEndTime) {
        errors.eventEndTime = errorMsg;
    }

    if (
        values.eventStartDate &&
        values.eventStartTime &&
        values.eventEndDate &&
        values.eventEndTime
    ) {
        const startDate = moment(values.eventStartDate).format('YYYY-MM-DD');
        const eventStartDateTime = moment(
            `${startDate} ${normalizeTimeField(values.eventStartTime)}`,
            'YYYY-MM-DD HH:mm'
        );
        const endDate = moment(values.eventEndDate).format('YYYY-MM-DD');
        const eventEndDateTime = moment(
            `${endDate} ${normalizeTimeField(values.eventEndTime)}`,
            'YYYY-MM-DD HH:mm'
        );
        // const startTime = moment(
        //     normalizeTimeField(values.eventStartTime),
        //     'HH:mm'
        // );
        // const endTime = moment(
        //     normalizeTimeField(values.eventEndTime),
        //     'HH:mm'
        // );
        if (eventEndDateTime.isSameOrBefore(eventStartDateTime)) {
            errors.eventEndTime =
                'ไม่สามารถเลือกเวลาสิ้นสุดกิจกรรมก่อนเวลาเริ่มกิจกรรมได้';
            errors.eventStartTime =
                'ไม่สามารถเลือกเวลาเริ่มกิจกรรมหลังเวลาสิ้นสุดกิจกรรมได้';
        }
    }

    if (
        values.isPublic === undefined ||
        values.isPublic === null ||
        values.isPublic === ''
    ) {
        errors.isPublic = errorMsg;
    }

    if (
        values.isRequiredCheckin === undefined ||
        values.isRequiredCheckin === null ||
        values.isRequiredCheckin === ''
    ) {
        errors.isRequiredCheckin = errorMsg;
    }

    if (values.isPublic === true) {
        if (!values.reserveStartDate) {
            errors.reserveStartDate = errorMsg;
        }
        if (!values.reserveStartTime) {
            errors.reserveStartTime = errorMsg;
        }
        if (!values.reserveEndDate) {
            errors.reserveEndDate = errorMsg;
        }
        if (!values.reserveEndTime) {
            errors.reserveEndTime = errorMsg;
        }

        if (
            values.eventStartDate &&
            values.eventStartTime &&
            values.reserveStartDate &&
            values.reserveStartTime &&
            values.reserveEndDate &&
            values.reserveEndTime
        ) {
            const startDate = moment(values.eventStartDate).format(
                'YYYY-MM-DD'
            );
            const eventStartDateTime = moment(
                `${startDate} ${normalizeTimeField(values.eventStartTime)}`,
                'YYYY-MM-DD HH:mm'
            );
            const reserveStartDate = moment(values.reserveStartDate).format(
                'YYYY-MM-DD'
            );
            const reserveStartDateTime = moment(
                `${reserveStartDate} ${normalizeTimeField(
                    values.reserveStartTime
                )}`,
                'YYYY-MM-DD HH:mm'
            );
            const reserveEndDate = moment(values.reserveEndDate).format(
                'YYYY-MM-DD'
            );
            const reserveEndDateTime = moment(
                `${reserveEndDate} ${normalizeTimeField(
                    values.reserveEndTime
                )}`,
                'YYYY-MM-DD HH:mm'
            );
            if (reserveStartDateTime.isSameOrAfter(eventStartDateTime)) {
                errors.reserveStartTime =
                    'ไม่สามารถเลือกเวลาหลังจากเวลาเริ่มกิจกรรมได้';
            }
            if (reserveEndDateTime.isSameOrAfter(eventStartDateTime)) {
                errors.reserveEndTime =
                    'ไม่สามารถเลือกเวลาหลังจากเวลาเริ่มกิจกรรมได้';
            }
            if (reserveEndDateTime.isSameOrBefore(reserveStartDateTime)) {
                errors.reserveEndTime =
                    'ไม่สารถเลือกเวลาก่อนเวลาเปิดลงทะเบียนล่วงหน้าได้';
            }
        }
        if (values.internalRequired) {
            if (
                values.internalCapacity === null ||
                values.internalCapacity === undefined ||
                values.internalCapacity === ''
            ) {
                errors.internalCapacity = errorMsg;
            } else if (values.internalCapacity < 0) {
                if (Number(values.internalCapacity) !== 0) {
                    errors.internalCapacity = 'จำนวนผู้เข้าร่วมต้องมากกว่า 0';
                }
            } else if (values.internalCapacity < values.internalReservedCount) {
                if (Number(values.internalCapacity) !== 0) {
                    errors.internalCapacity =
                        'กรุณาระบุจำนวนที่มากกว่า ' +
                        values.internalReservedCount;
                }
            }
        }
        if (values.externalRequired) {
            if (
                values.externalCapacity === null ||
                values.externalCapacity === undefined ||
                values.externalCapacity === ''
            ) {
                errors.externalCapacity = errorMsg;
            } else if (values.externalCapacity < 0) {
                if (Number(values.externalCapacity) !== 0) {
                    errors.externalCapacity = 'จำนวนผู้เข้าร่วมต้องมากกว่า 0';
                }
            } else if (values.externalCapacity < values.externalReservedCount) {
                if (Number(values.externalCapacity) !== 0) {
                    errors.externalCapacity =
                        'กรุณาระบุจำนวนที่มากกว่า ' +
                        values.externalReservedCount;
                }
            }
        }
    }

    if (values.isPublic === false) {
        if (!values.reserveFile) {
            errors.reserveFile = errorMsg;
        }
    }

    if (!values.mainCoordinator) {
        errors.mainCoordinator = errorMsg;
    }

    if (values.isRequiredCheckin === true) {
        if (!values.checkInLeadTime) {
            errors.checkInLeadTime = errorMsg;
        }
    }

    // both case from quill text editor have excess <p><br></p> on emptyString ''
    if (values.eventDescription === '<p><br></p>') {
        errors.eventDescription = errorMsg;
    }

    // if (
    //     !values.coordinator ||
    //     (Array.isArray(values.coordinator) && values.coordinator.length === 0)
    // ) {
    //     errors.coordinator = errorMsg;
    // }

    return errors;
};

const convertDateToDateTimeFlatForm = (dateString) => {
    return new Date(new Date(dateString).setHours('00'));
};

export const sanitizeEventFormFields = (ApiData) => {
    if (ApiData.eventStartDate) {
        ApiData.eventStartDate = convertDateToDateTimeFlatForm(
            ApiData.eventStartDate
        );
    }
    if (ApiData.eventEndDate) {
        ApiData.eventEndDate = convertDateToDateTimeFlatForm(
            ApiData.eventEndDate
        );
    }
    if (ApiData.reserveStartDate) {
        ApiData.reserveStartDate = convertDateToDateTimeFlatForm(
            ApiData.reserveStartDate
        );
    }
    if (ApiData.reserveEndDate) {
        ApiData.reserveEndDate = convertDateToDateTimeFlatForm(
            ApiData.reserveEndDate
        );
    }
    ApiData.coordinatorTemp = ApiData.coordinators;
    if (ApiData.coverImage) {
        ApiData.coverImage = [
            {
                url: ApiData.coverImage,
            },
        ];
    }

    if (ApiData.mainCoordinator) {
        ApiData.mainCoordinator = ApiData.mainCoordinator.userId;
    }

    delete ApiData.canCancel;
    delete ApiData.canEdit;
    delete ApiData.canceledAt;
    delete ApiData.canceledBy;
    delete ApiData.checkInCount;
    delete ApiData.createdAt;
    delete ApiData.createdBy;
    delete ApiData.favoriteCount;
    delete ApiData.reservedCount;
    delete ApiData.statusId;
    delete ApiData.statusName;
    delete ApiData.totalCapacity;
    delete ApiData.updatedAt;
    delete ApiData.updatedBy;
    delete ApiData.viewCount;
    delete ApiData.walkInCount;

    return ApiData;
};

export const createUpdateEventFormData = async (formValues, uuid, isEdit) => {
    const formData = new FormData();
    for (const field in formValues) {
        if (
            field === 'coverImage' ||
            field === 'reserveFile' ||
            formValues[field] === undefined ||
            formValues[field] === null ||
            field === 'internalRequired' ||
            field === 'externalRequired' ||
            field === 'internalCapacity' ||
            field === 'externalCapacity'
        ) {
            if (field === 'coverImage' && formValues[field]) {
                formData.append(
                    field,
                    Array.isArray(formValues[field]) &&
                        formValues[field].length > 0 &&
                        formValues[field][0].hasOwnProperty('url')
                        ? formValues[field][0].url
                        : ''
                );
            }
            if (field === 'internalCapacity') {
                if (formValues['internalRequired'] === false) {
                    formData.append(field, null);
                } else {
                    formData.append(field, formValues[field]);
                }
            } else if (field === 'externalCapacity') {
                if (formValues['externalRequired'] === false) {
                    formData.append(field, null);
                } else {
                    formData.append(field, formValues[field]);
                }
            }
            continue;
        }

        if (Array.isArray(formValues[field])) {
            if (field === 'coordinators') {
                if (formValues[field].length > 0) {
                    formData.append(
                        field,
                        formValues[field].map((coord) => coord.userId)
                    );
                }
            } else {
                formData.append(field, JSON.stringify(formValues[field]));
            }
        } else if (field === 'createdBy') {
            formData.append(field, formValues[field].userId);
        } else if (DateFields.includes(field)) {
            if (formValues[field] instanceof Date) {
                formData.append(
                    field,
                    moment(formValues[field]).format('YYYY-MM-DD')
                );
            } else if (typeof formValues[field] === 'string') {
                formData.append(field, formValues[field]);
            }
        } else if (TimeFields.includes(field)) {
            if (formValues[field] instanceof Date) {
                formData.append(
                    field,
                    moment(formValues[field]).format('HH:mm')
                );
            } else {
                formData.append(field, formValues[field]);
            }
        } else if (field === 'canceledBy') {
            if (!formValues[field]) {
                continue;
            } else {
                formData.append(field, formValues[field].userId);
            }
        } else if (
            field === 'speakers' &&
            formValues['speakers'] === '<p><br></p>'
        ) {
            formData.append(field, null);
        } else {
            formData.append(field, formValues[field]);
        }
    }

    if (!isEdit) {
        formData.append('createdBy', uuid);
    }

    formData.append('updatedBy', uuid);

    if (formValues.coverImage && formValues.coverImage[0]) {
        const imgData = formValues.coverImage[0];
        if (!imgData.url) {
            const base64Res = await fetch(
                `data:image/${imgData.type};base64,${imgData.data}`
            );
            const blob = await base64Res.blob();
            formData.append(
                'coverImage',
                blob,
                imgData.filename + '.' + imgData.type
            );
        }
    }
    if (formValues.reserveFile) {
        const reserveFile = formValues.reserveFile;
        if (reserveFile instanceof File) {
            formData.append('reserveFile', reserveFile);
        }
    } else if ('reserveFile' in formValues && formValues.reserveFile === null) {
        formData.append('reserveFile', null);
    }
    return formData;
};

export const constructEventDateTimeString = (datePart, timePart) => {
    // datePart in YYYY-MM-DD
    // timePart in HH:mm

    if (datePart && timePart) {
        return (
            convertDateDisplay(formatDate(new Date(datePart))) +
            ' ' +
            `${timePart} น.`
        );
    } else if (datePart && !timePart) {
        return (
            convertDateDisplay(formatDate(new Date(datePart))) +
            ' ' +
            `ไม่ระบุช่วงเวลา`
        );
    } else {
        return '-';
    }
};

export const appendFullNameUserArray = (userArray) => {
    for (let i = 0; i < userArray.length; i++) {
        userArray[
            i
        ].fullName = `${userArray[i].firstName} ${userArray[i].lastName}`;
    }
    return userArray;
};

export const validateRegisterEventFormExternal = (values) => {
    const errorMsg = 'กรุณาระบุข้อมูล';
    const errors = {};

    if (values.isInternal === false) {
        // case external all field required;
        if (!values.email) {
            errors.email = errorMsg;
        }

        if (!values.firstName) {
            errors.firstName = errorMsg;
        }

        if (!values.lastName) {
            errors.lastName = errorMsg;
        }

        if (!values.companyName) {
            errors.companyName = errorMsg;
        }

        if (!values.position) {
            errors.position = errorMsg;
        }
    }

    return errors;
};

export const formatDisplayNumber = (num) => {
    const number = Number(num);
    if (isNaN(number)) return null;
    return number.toLocaleString('en-US');
};
